module.exports = __webpack_public_path__ + "img/sloth-delivery.2c0e49ff.png";